export const config = {
	typeRetirement: {
		pharmacy: 'Retiro en Farmacia',
		home: 'Envío a Domicilio',
	},
	log: {
		true: 'Registrado',
		false: 'Incógnito',
	},
	delivery: {
		home: 'domicilio',
		pharmacy: 'farmacia',
	},
};